<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      门店管理
      <small>
        /&nbsp;
        <a href="javascript:void(0);" @click="GoBack" style="color: #6a7786;">商品上下架</a>&nbsp;/&nbsp;商品详情
      </small>
    </h1>
    <!-- end col-6 -->
    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->
        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">商品列表详情</h4>
              </div>
              <!-- end panel-heading -->
              <div class="OrderInfo">
                <div class="OrderGroup">
                  <div class="GTitle">
                    <span class="TInfo">商品信息</span>
                  </div>
                  <div class="GContent">
                    <ul class="GContentUl">
                      <li class="TableContent">
                        <span class="TCode">商品编码：</span>
                        <span class="TCodeContent">{{GoodList.goodsCode}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">商品名称：</span>
                        <span class="TCodeContent">{{GoodList.goodsName}}</span>
                      </li>
                

                      <li class="TableContent">
                        <span class="TCode">单位：</span>
                        <span class="TCodeContent">{{GoodList.unit}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">分类：</span>
                        <span class="TCodeContent">{{GoodList.categoryName}}</span>
                      </li>

                      <li class="TableContent">
                        <span class="TCode">品牌：</span>
                        <span class="TCodeContent">{{GoodList.brandName}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">系列：</span>
                        <span class="TCodeContent">{{GoodList.seriesName}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">库存数：</span>
                        <span class="TCodeContent">{{GoodList.reserve}}</span>
                      </li>

                      <li class="TableContent">
                        <span class="TCode">下单数：</span>
                        <span class="TCodeContent">{{GoodList.orderCount}}</span>
                      </li>

                      <li class="TableContent">
                        <span class="TCode">是否含税:</span>
                        <span class="TCodeContent">{{GoodList.istax}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">税率：</span>
                        <span class="TCodeContent">{{GoodList.taxrate}}</span>
                      </li>

                      <li class="TableContent">
                        <span class="TCode">原产国代码：</span>
                        <span class="TCodeContent">{{GoodList.placeOfOriginCode}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">原产国名称：</span>
                        <span class="TCodeContent">{{GoodList.baseName}}</span>
                      </li>
                  
                      <li class="TableContent">
                        <span class="TCode">商品来源：</span>
                        <span class="TCodeContent">{{GoodList.source}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">毛重：</span>
                        <span class="TCodeContent">{{GoodList.weight}}kg</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">净重：</span>
                        <span class="TCodeContent">{{GoodList.netWeight}}kg</span>
                      </li>
                       <li class="TableContent">
                        <span class="TCode">条形码：</span>
                        <span class="TCodeContent">{{GoodList.barCode}}</span>
                      </li>    
                      <li class="TableContent">
                        <span class="TCode">商品规格：</span>
                        <span class="TCodeContent">{{GoodList.specs}}</span>
                      </li>
                      <li class="clear"></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="OrderInfo">
                <div class="OrderGroup">
                  <div class="GTitle">
                    <span class="TInfo">商品图片</span>
                  </div>
                  <div class="GContent">
                    <ul class="GContentUl">
                      <li class="TableContent"   v-for="(item,index) in MainPicture" :key="index"  style="width:100%">
                        <span class="TCode">主图：</span>
                        <span class="TCodeContent"> <img :src="item.url" style="width:200px;"/></span>
                      </li>
                       <li class="TableContent" v-for="(item,index) in PictureList"  :key="item.url" style="width:100%">
                        <span class="TCode">展示图{{index +1}}：</span>
                        <span class="TCodeContent" ><img :src="item.url" style="width:200px;"/></span>
                      </li>
                       <li class="clear"></li>
                       </ul>
                     
                  </div>
                </div>
              </div>
              <div class="OrderInfo">
                <div class="OrderGroup">
                  <div class="GTitle">
                    <span class="TInfo">商品详情</span>
                  </div>
                  <div class="GContent">
                    <ul class="GContentUl">
                     

                     
                    
                      <li class="TableContent" v-for="(item,index) in GoodLists" :key="index" style="width:50%">
                        <span class="TCode">详情图{{index+1}}：</span>
                        <span class="TCodeContent">
                           <el-tooltip class="item" effect="dark" :content="item.description" placement="top-start">
                          <img :src="item.imageUrl" style="width:200px;"/>
                           </el-tooltip>
                           <br/>
                        <span style="margin-left:80px;">权重：{{item.weights}}</span>
                        </span>
                      </li>

                      <li class="clear"></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="OrderInfo">
                <div class="OrderGroup">
                  <div class="GTitle">
                    <span class="TInfo">商品属性</span>
                  </div>
                  <div class="GContent">
                    <el-table :data="GoodAttributes" border style="width: 100%">
                      <el-table-column prop="proCode" label="属性编码"></el-table-column>
                      <el-table-column prop="proName" label="属性名称"></el-table-column>
                      <el-table-column prop="proValue" label="属性值"></el-table-column>
                      <el-table-column prop="proUnit" label="单位"></el-table-column>
                   
                    </el-table>
                  </div>

                  <div style="height:46px;padding-top:16px;">
                    <a class="btn btn-primary m-r-5 BackButton" @click="GoBack">返&nbsp;&nbsp;回</a>

                    <span class="clear"></span>
                  </div>
                </div>

                <!-- end panel -->
              </div>
            </div>
            <!-- end col-10 -->
          </div>
        </div>
        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>
  </div>
</template>
<script>
import Qs from "qs";
import axios from "axios";
import http from "@/common/http";

export default {
  name: "InfoDetail",
  data() {
    return {
      goodsId: "",
      pageNo: 1,
      GoodList:{},
      GoodLists:[],
      GoodAttributes:[],
      PictureList:[],
      MainPicture:[],
      pageSize:10,
      pageNo:1,
      recom_id:'',
      shop_id:''
    };
  },
  mounted: function() {
    if(this.$route.query.recomId){
      this.recom_id = this.$route.query.recomId;
    }
    if(this.$route.query.shopId){
      this.shop_id = this.$route.query.shopId;
    }
    this.initdata();
    this.initdatasecond();
    this.initProperties();
    this.initPicture();
  },
  methods: {
 
    initdata() {
      if (localStorage.getItem("goodlist")) {
        let goodlist = localStorage.getItem("goodlist");
        this.goodsId = JSON.parse(goodlist).goodsId;
        this.pageNo = JSON.parse(goodlist).pageNo;
        this.pageSize = JSON.parse(goodlist).pageSize;
        this.searchContent =  JSON.parse(goodlist).searchContent;
        let that = this;
        const options = {
          url: "distribution/B2cGoodsInfoController/queryOneGoodsInfo",
          method: "post",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          data: Qs.stringify({
            goodsId: that.goodsId
          })
        };
        axios(options)
          .then(function(response) {
            if (response.data.code == 200) {
            
            
              that.GoodList = response.data.data;
              if(that.GoodList.isTax === 1){
                that.GoodList.istax = '是';
              }else if(that.GoodList.isTax === 0){
                 that.GoodList.istax = '否';
              }
              if(that.GoodList.source === 0){
                   that.GoodList.sourcedetail = '中台'
              }else if(that.GoodList.source === 1){
                 that.GoodList.sourcedetail = '自定义'
              }
            that.GoodList.taxrate = that.GoodList.taxrate*100 +"%"  
            
            } else {
               http.handleEorrorCode(response,that);
            }
          })
          .catch(function(error) {
            http.handleHttpError(error, that);
          });
      }
    },  
    initProperties(){
     let that = this;
        const options = {
          url: "distribution/B2cGoodsInfoController/queryOneGoodProperties",
          method: "post",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          data: Qs.stringify({
            goodsId: that.goodsId
          })
        };
        axios(options)
          .then(function(response) {
            if (response.data.code == 200) {
            

              that.GoodAttributes = response.data.data;
             
            } else {
              http.handleEorrorCode(response,that);
            }
          })
          .catch(function(error) {
            http.handleHttpError(error, that);
          });
    },
    initPicture(){
      let that = this;
      let arr = [];
      let arrs = [];
        const options = {
          url: "distribution/B2cGoodsFilesController/queryGoodsFiles",
          method: "post",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          data: Qs.stringify({
            goodsId: that.goodsId
          })
        };
        axios(options)
          .then(function(response) {
            if (response.data.code == 200) {
              response.data.data.forEach(element => {
                if(element.isMain === 1){
                  arr.push(element) 
                }
                if(element.isMain === 0){
                  arrs.push(element)
                }
              });
              that.MainPicture = arr
              
              that.PictureList = arrs;
         
            } else {
               http.handleEorrorCode(response,that);
            }
          })
          .catch(function(error) {
            http.handleHttpError(error, that);
          });
    },
    initdatasecond(){
        let that = this;
        const options = {
          url: "distribution/B2cGoodsInfoController/queryGoodDetailById",
          method: "post",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          data: Qs.stringify({
            goodsId: that.goodsId
          })
        };
        axios(options)
          .then(function(response) {
            if (response.data.code == 200) {
            

              that.GoodLists = response.data.data;
           
            } else {
              http.handleEorrorCode(response,that);
            }
          })
          .catch(function(error) {
            http.handleHttpError(error, that);
          });
    },
    GoBack() {
        this.$router.push({ name: "O2OGoodsShelves", query: {recomId: this.recom_id,shopId: this.shop_id}, params: { pageNo: this.pageNo, pagesize: this.pageSize, searchContent: this.searchContent}});
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ModelPadding {
  margin-top: -30px;
}
.LineSpacing {
  margin-top: 16px;
}
.ButtonColor {
  color: #fff !important;
}

.OrderInfo {
  padding: 20px 30px;
}
.GTitle {
  border-top: 3px #84caf3 solid;
  overflow: hidden;
  line-height: 25px;
  border-right: 1px #e5e5e5 solid;
  background: #f4f4f4;
}
.TInfo {
  position: relative;
  min-width: 130px;
  float: left;
  font-size: 16px;
  padding: 5px 15px;
  background-color: #84caf3;
  color: #ffffff;
}
.GContent {
  padding: 15px;
  border: 1px #e5e5e5 solid;
  border-top: none;
}

.TitleStyle {
  color: #6a7786;
}
@media screen and (min-width:1360px) and (max-width:1680px){ /*二栏布局*/ .TableContent{width: 50%;}  }
@media screen and (min-width:1680px) and (max-width:2000px){ /*二栏布局*/ .TableContent{width: calc(100%/3);}  }
.TableContent {
  float: left;
}
.GContentUl {
  list-style: none;
}
.TCode {
  color: #999999;
  text-align: left;
  display: inline-block;
  width: 105px;
  overflow: hidden;
  font-size: 14px;
  float: left;
  padding-left: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.TCodeContent {
  font-size: 12px;
  float: left;
  width: calc(100% - 105px);
  line-height: 20px;
  text-align: left;
  word-break: normal;
  word-wrap: break-word;
  padding-top: 8px;
  padding-bottom: 8px;
}
.BackButton {
  float: right;
  cursor: pointer;
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/O2OShopSetting/O2OGoodsShelvesDetail.vue